import { Pipe, PipeTransform } from '@angular/core';

/**
 * Directive used to replace gaps in code with dynamic properties
 *
 * {{ 'some static copy with % and %' |  vars : 'string1' : 'string2' }}
 *
 * will print: some static copy with string1 and string2'
 *
 *
 * {{ 'some static copy with %2 |  vars : 'string1' : 'string2' }}
 *
 * will print: some static copy with string2'
 *
 */
@Pipe({
    standalone: true,
    name: 'vars'
})
export class VarsPipe implements PipeTransform {
    transform(value: string, ...params: (string | number)[]) {
        if (typeof value !== 'string') {
            return value;
        }
        let index = 0;
        return value.replace(/%(\d)*/g, (fullString: string, requestedIndex: string): string => {
            let readIndex: number;
            if (requestedIndex) {
                readIndex = parseInt(requestedIndex, 10) - 1;
            } else {
                readIndex = index;
                index++;
            }
            const param = params[readIndex];
            if (typeof param === 'number' && param === 0) {
                return param + '';
            }
            return param ? param + '' : '';
        });
    }
}
